import React from 'react';
import { Card, CardHeader, CardContent, Stack } from '@mui/material';
import { ContactDataForm } from '../../ContactDataForm';

const WRRepresentativesForm = ({ formik }) => (
  <Stack direction="row" justifyContent="space-between" m={2} spacing={2} maxWidth={'50%'}>
    <Card style={{ flex: '1 1 50%' }}>
      <CardHeader title="Dane zamawiającego" sx={{ mt: -1 }} />
      <CardContent>
        <ContactDataForm
          formik={formik}
          type="guardian"
          name="guardian_name"
          streetAddress="guardian_street_address"
          postalCode="guardian_postal_code"
          city="guardian_city"
          nipOrPesel="guardian_nip"
          phoneNumber="guardian_phone"
          additionalPhone="guardian_additional_phone"
          email="guardian_correspondence_email"
          guardian_pesel="guardian_pesel"
        />
      </CardContent>
    </Card>
  </Stack>
);

export default WRRepresentativesForm;
